export const INTAKE_PAGE_SLUGS: Record<string, string> = {
  K1: 'key-questions',
  F1: 'what-we-need',
  M1: 'clinic-documents',
  M2: 'practice-identity',
  M3: 'addresses-contacts',
  M5: 'provider-roster',
  M6: 'clinic-review',
  P1: 'your-documents',
  P2: 'your-identifiers',
  P3: 'licenses-states',
  P4: 'malpractice',
  P5: 'about-you',
  P6: 'your-review',
  X1: 'confirm-completion',
  T1: 'items-we-need-later',
};

const INTAKE_SLUG_PAGE_KEYS = new Map(
  Object.entries(INTAKE_PAGE_SLUGS).map(([pageKey, slug]) => [slug, pageKey]),
);

export function intakePagePath(pageKey: string): string {
  return `/intake/${INTAKE_PAGE_SLUGS[pageKey] ?? INTAKE_PAGE_SLUGS.K1}`;
}

export function resolveIntakePageKey(pathname: string): string | null {
  const parts = pathname.split('/').filter(Boolean);
  const intakeIndex = parts.lastIndexOf('intake');
  const slug = intakeIndex >= 0 ? parts[intakeIndex + 1] : undefined;
  return slug ? (INTAKE_SLUG_PAGE_KEYS.get(slug) ?? null) : null;
}

/** The Intake Hub's own root — section one, the stepped form, on first load. */
export const INTAKE_ROOT_PATH = '/intake';

/**
 * Section two (GDN-3405). Deliberately a sibling slug under the existing
 * `/intake/:step?` route rather than a route of its own: every slug in
 * `INTAKE_PAGE_SLUGS` keeps resolving exactly as it did before the shell, so
 * no legacy form path moves and none needs a redirect (AC-21).
 *
 * `resolveIntakePageKey` returns null for it, because it is not a form step.
 */
export const PAYER_CONNECTIONS_SLUG = 'payer-connections';
export const PAYER_CONNECTIONS_PATH = `${INTAKE_ROOT_PATH}/${PAYER_CONNECTIONS_SLUG}`;

/** True when `pathname` addresses the Payer connections section. */
export function isPayerConnectionsPath(pathname: string): boolean {
  const parts = pathname.split('/').filter(Boolean);
  const intakeIndex = parts.lastIndexOf('intake');
  return intakeIndex >= 0 && parts[intakeIndex + 1] === PAYER_CONNECTIONS_SLUG;
}

export function hasIntakeV2DevelopmentOverride(search: string): boolean {
  return import.meta.env.DEV && new URLSearchParams(search).get('v2') === '1';
}

/** Explicit opt-in agreement entry; existing intake slugs retain their meaning. */
export const AGREEMENTS_PATH = `${INTAKE_ROOT_PATH}/agreements`;
export function isAgreementsPath(pathname: string): boolean {
  return pathname.replace(/\/$/, '') === AGREEMENTS_PATH;
}
